import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Volumes/Crucial 1TB X9/Documents/Rank Craft Ai/projects/luluwild/site/components/OpenTableWidget.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Volumes/Crucial 1TB X9/Documents/Rank Craft Ai/projects/luluwild/site/node_modules/next/dist/client/app-dir/link.js");
